import type { RadioProps as AntRadioProps } from 'antd';
import { Radio as AntRadio } from 'antd';
import React from 'react';
import {
  RadioContainer,
  StyledHelpText,
  StyledLabel,
  StyledRadioWrapper
} from './styled';

export interface RadioButtonProps extends Omit<AntRadioProps, 'children'> {
  label: string;
  helpText?: string;
  hasError?: boolean;
}

export const RadioButton: React.FC<RadioButtonProps> = ({
  label,
  helpText,
  hasError = false,
  disabled = false,
  ...props
}) => {
  return (
    <RadioContainer>
      <StyledRadioWrapper $disabled={disabled} $hasError={hasError}>
        <AntRadio disabled={disabled} {...props}>
          {!!label && (
            <StyledLabel
              variant="body1"
              $disabled={disabled}
              $hasError={hasError}
            >
              {label}
            </StyledLabel>
          )}
        </AntRadio>
      </StyledRadioWrapper>
      {!!helpText && (
        <StyledHelpText
          variant="body1"
          $disabled={disabled}
          $hasError={hasError}
        >
          {helpText}
        </StyledHelpText>
      )}
    </RadioContainer>
  );
};
